import { cn } from '../cn';

function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn('bg-primary/40 animate-pulse rounded-md', className)}
      {...props}
    />
  );
}

export { Skeleton };
